<script lang="ts">
  import { EmptyLabelDefault } from '$provider/constants/global';

  interface AddressType {
    addressLine1: string;
    addressLine2?: string;
    city?: string;
    state?: string;
    zip?: string;
    country?: string;
    phone?: string;
    fax?: string;
  }
  interface Props {
    value: AddressType;
  }

  let { value }: Props = $props();

  let cityLine =
    $derived(value &&
    [
      value.city || '',
      value.state || '',
      value.zip || value.postalCode || value.zipCode || '',
      value.country || value.countryCode || ''
    ]
      .filter(Boolean)
      .join(', ')
      .trim());
</script>

<div class="comp-address-list-type">
  {#if value}
    {#if value.addressLine1}
      <div class="segment">{value.addressLine1}</div>
    {/if}
    {#if value.addressLine2}
      <div class="segment">{value.addressLine2}</div>
    {/if}
    {#if cityLine}
      <div class="segment">
        {cityLine}
      </div>
    {/if}
    <div class="segement">
      <div class="contact">
        {#if value.phone || value.telephoneNumber}
          <div class="contact-i">Phone: {value.phone || value.telephoneNumber}</div>
        {/if}
        {#if value.fax || value.faxNumber}
          <div class="contact-i">Fax: {value.fax || value.faxNumber}</div>
        {/if}
      </div>
    </div>
  {:else}
    {EmptyLabelDefault}
  {/if}
</div>

<style>
  .segment:not(:last-child) {
    margin-bottom: 8px;
  }
  .contact {
    display: flex;
    align-items: center;
  }
  .contact-i:not(:last-child) {
    margin-right: 8px;
  }
</style>
